import { defineFeatureFlags } from '@shared/featureFlags/defineFeatureFlags';

export enum AppDesignFeatureFlag {
  SwitchEnabled = 'appDesignSwitchEnabled',
  NewDesignEnabled = 'newDesignEnabled',
}

export const AppDesignFeatureGate = defineFeatureFlags(AppDesignFeatureFlag, {
  SwitchEnabled: {},
  NewDesignEnabled: {},
});
